import { myAbout } from "./data";

export default function About () {
    return ( 
        <section className="about-section">
          <div className="about">
          <div className="aboutTitle">
                <h1>About<span>  Me    </span></h1>
               
            </div>
           {myAbout.map((about) => (
        <div className="about-container">
            <p>{about.content}</p>
            <p>{about.contentTwo}</p>
            <br/>
            <p>{about.contentThree}</p>
            <div className="links">
            <a className="btn-background" href="">View Works</a>
            <a className="btn-bordered" href="">Download CV</a>
            </div>
        </div>
        ))}
          </div>
     
            
        </section>
    );
}
 
